import React, { useState, useRef } from 'react';
import { track } from '@vercel/analytics';

const SearchBar = ({ onSearch, onNavigate, currentMatch, totalMatches }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearchMode, setIsSearchMode] = useState(true);
  const trackedKeywords = useRef(new Set());

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
    setIsSearchMode(true); // Reset to search mode when typing
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && searchTerm.trim()) {
      if (isSearchMode) {
        // First Enter - perform search and let Timeline handle going to first match
        // console.log(`Tracked search keyword: ${searchTerm.trim()}`);
        // Track search keywords with Vercel Analytics only on first Enter for each keyword
        const keyword = searchTerm.trim();
        // console.log('Keyword:', keyword);
        // console.log('Already tracked keywords:', Array.from(trackedKeywords.current));
        // console.log('Has keyword been tracked?', trackedKeywords.current.has(keyword));
        
        if (!trackedKeywords.current.has(keyword)) {
          // console.log('Adding keyword to tracked set and calling track()');
          trackedKeywords.current.add(keyword);
          track('search', {
            keyword: keyword,
            timestamp: new Date().toISOString()
          });
        } else {
          // console.log('Keyword already tracked, skipping track()');
        }
        
        // Perform the search
        onSearch(searchTerm.trim());
        setIsSearchMode(false); // Switch to navigation mode
        // Don't navigate here - let Timeline handle the first match
      } else {
        // Subsequent Enters - navigate through matches
        if (totalMatches > 0) {
          e.preventDefault();
          onNavigate('next');
        }
      }
    } else if (e.key === 'ArrowDown' && totalMatches > 0) {
      e.preventDefault();
      onNavigate('next');
    } else if (e.key === 'ArrowUp' && totalMatches > 0) {
      e.preventDefault();
      onNavigate('previous');
    }
  };

  const clearSearch = () => {
    setSearchTerm('');
    setIsSearchMode(true);
    onSearch('');
  };

  const handlePrevious = () => {
    if (onNavigate) onNavigate('previous');
  };

  const handleNext = () => {
    if (onNavigate) onNavigate('next');
  };

  return (
    <div className="search-container">
      <div className="search-input-wrapper">
        <input
          type="text"
          placeholder="Search timeline..."
          value={searchTerm}
          onChange={handleSearch}
          onKeyDown={handleKeyDown}
          className="search-input"
        />
        {searchTerm && (
          <button onClick={clearSearch} className="search-clear">
            ×
          </button>
        )}
        {totalMatches > 0 && (
          <div className="search-navigation">
            <span className="match-count">
              {currentMatch} of {totalMatches}
            </span>
            <button 
              onClick={handlePrevious} 
              className="nav-button"
              disabled={currentMatch <= 1}
            >
              ↑
            </button>
            <button 
              onClick={handleNext} 
              className="nav-button"
              disabled={currentMatch >= totalMatches}
            >
              ↓
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
